import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { checkBeforeJoin } from '@/common/http/meet';
import { isSuccessCode } from '@/common/utils/response';
import { logger } from '@/common/utils/logger';
import { TResponse } from '@/common/basis/types/tresponse';
import configJson from '@/common/basis/config.json';

function App(props: { children?: React.ReactNode; roomId?: string; callback?: (success: boolean) => void }) {
  const roomId = props.roomId;
  const callback = props.callback;
  const [messageApi, contextHolder] = message.useMessage({ top: 60 });
  const { t } = useTranslation();

  return (
    <>
      {props.children}
      <div
        className='absolute bottom-0 left-0 right-0 top-0 z-50 h-full w-full'
        onClick={async () => {
          const resp = await checkBeforeJoin({ roomId });

          if (isSuccessCode(resp.code)) {
            callback?.(true);

            return;
          } else if (resp.code === TResponse.CODE_445) {
            // 445:强制入会
            messageApi.destroy();
            messageApi.warning(t('youAreInMeeting'));
          } else if (resp.code === TResponse.CODE_201) {
            // 201切换设备
            messageApi.destroy();
            messageApi.warning(t('otherDeviceInCall'));
          } else if (resp.code === TResponse.CODE_444) {
            // 444:会议不存在
            if (resp.data?.clientType === configJson.clientId) {
              messageApi.destroy();
              messageApi.warning(t('youAreInMeeting'));
            } else {
              messageApi.destroy();
              messageApi.warning(t('otherDeviceInCall'));
            }
          } else {
            logger().warn('CheckBeforeJoin failed', resp);
            messageApi.destroy();
            messageApi.warning(resp.msg);
          }
          callback?.(false);
        }}
      />

      {contextHolder}
    </>
  );
}

export default App;
